//Portuguese (Brazil)
export default {
    homeScreen : {
        startConversation: 'Iniciar uma conversa',
        newConversationButton: 'Ajuda',
        newMessageButton: '+ UMA mensagem',
        allTopics: 'All topics',
        allChatsButton: 'Ver tudo',
        poweredBy: 'Distribuído por Richpanel',
        reOpenConversation: 'Reabrir conversa',
        recentConversations: 'Suas conversas',
        startAChat: 'Começar um chat',
        noRecentConversations: 'Não há conversas recentes',
        noRecentOrders: 'Não há pedidos recentes',
        haveAQuestion: "Tem alguma dúvida? Fale conosco por aqui.",
        conversationClosed: `Esta conversa foi marcada como fechada. Se tem alguma dúvida sobre esse problema, reabra esta conversa.`,
        retry: 'Tentar novamente',
        errorOccured: 'Ocorreu um erro durante o processamento da sua solicitação.',
        successMessage: 'Recebemos sua solicitação e nossa equipe irá vai entrar em contato no {email}',
        loadingMessage: 'Por favor aguarde. Estamos submetendo sua solicitação.',
        goHome: 'Voltar ao início.',
        sendUsMessage: 'Envie-nos uma mensagem',
        endChat: 'FIM DE PAPO',
        goto: 'Vamos para',
    },
    orderStatuses: {
        'completed': 'Completo',
        'pending': 'Pendente',
        'on hold': 'Em espera',
        'processing': 'A processar',
        'cancelled': 'Cancelado',
        'fulfilled': 'Enviado',
        'confirmed': 'Confirmado',
    },

    loginScreen: {
        title: 'Inicia sessão no centro de ajuda',
        titleForOrdersScreenForward: 'Inicia sessão para visualizar seus pedidos ',
        userIdFieldTitle: "Seu e-mail ou telefone",
        userIdFieldPlaceHolder: "Introduzir e-mail/telefone",
        sendCode: "Indroduza",
        enterCode: 'Introduza o código que nós enviamos',
        enterTheCode: 'Indroduza o código',
        notYourUserId: 'Não é o seu {userIdType}?',
        userIdTypes: {
            'phone': 'número',
            'email': 'e-mail',
        },
        change: 'Editar',
        notReceivedCode: "Não recebeu o código?",
        resendCode: 'Reenviar',
        in: 'in',
        verifyCode: 'VERIFICAR',
        logout: 'Logout',
        orderNumberFieldTitle: 'Digite o número do pedido para que possamos ajudar	',
        orderNumberFieldPlaceholder: 'Digite o número do pedido Ex: 1234',
        zipcodeFieldTitle: 'Seu CEP',
        zipcodeFieldPlaceholder: 'Digite o CEP	',
        emailFieldTitle: 'E-mail',
        emailFieldPlaceholder: 'Digite seu e-mail',
    },

    orderList : {
        reorder: 'REPETIR PEDIDO',
        getHelp: 'OBTER AJUDA',
        startNewConversation: 'INICIAR UMA NOVA CONVERSA',
        viewPreviousOrder:'VER TODOS OS PEDIDOS',
        seeAll: 'Ver tudo',
        viewMoreOrders: 'VER MAIS PEDIDOS',
        viewOrderStatus: 'VER STATUS DOS PEDIDOS',
        chatWithUs: 'CONVERSE CONNOSCO',
        issueWithPreviousOrder:'AJUDA COM PEDIDOS ANTERIORES' ,
        orderLabel: 'Pedido',
        help: 'AJUDA',
        lastOrder: 'Último pedido',
        selectRelevantItems: 'Selecionar itens relevantes',
        selectItemsErrorMsg: 'Por favor seleciona os artigos a incluir ',
        selectAll: 'Selecionar tudo',
        selectQuantity: 'Quantos itens?',
        helpWithThisOrder: 'Ajuda com este pedido',
        yourOrders: 'Seus pedidos ',
        view: 'VER',
        track: 'ACOMPANHAR PEDIDO',
        addressTitle: 'Resumo do pedido',
        billingAddressTitle: 'MORADA DE COBRANÇA',
        shippingAddressTitle: 'itens',
        receiptTitle: 'items',
        itemTotal: 'Item(s) total',
        taxes: 'Impostos',
        discounts: 'Descontos',
        giftCard: 'Gift Card', 
        deliveryCharges: 'Taxa de entrega',
        total: 'Total',
        loginToViewOrders: 'Ajuda com um pedido existente?',
        loginSuggestion: "Obtenha ajuda com pedidos",
        trackingOrderLabel: 'Localizar pedido',
        shipmentDescription: "Volte a esta página para atualizações no status do seu pedido",
        free: "grátis",
        selectedItems: "Itens Selecionados",
        items: "Itens",
        "orderSearchPlaceholder": 'Filter by order #',
        "noOrderFound": 'No orders matching {orderId}',
    },
    chatListScreen: {
        header: 'Suas conversas',
    },
    sentences: {
        "IN_A_DAY" : "Nossa equipe geralmente responde em um dia.",
        "IN_FEW_MINUTES": "Nossa equipe geralmente responde em minutos.",
        "IN_FEW_HOURS": "Nossa equipe geralmente responde em algumas horas.",
        "AS_SOON_AS_THEY_CAN": "Nossa equipe vai responder o mais rápido possível",
        "BACK_ON": "Voltamos em",
        "BACK_IN": "Voltamos em",
        "HOURS": "Horas",
        "MINUTES": 'Minutos',
        provideBelowDetails: "Por favor introduza os detalhes abaixo",
    },
    inputFields: {
        submitted: 'submetido'
    },
    inputPropDisplayNames: {
        "email": "E-mail",
        "phone": "Telefone",
        "Phone": "Telefone",
        "firstName": "Nome",
        "lastName": "Apelido",
        "uid": "Usuário",
        "campaign": "Campanha UTM",
        "medium": "Médio UTM",
        "googleplus": "Google plus",
        "shippingPhone": "Telefone de cobrança",
        "source": "Fonte UTM",
        "lastOrderAt": "Hora do último pedido",
        "firstOrderAt": "Hora do primeiro pedido",
        "visits": "Sessão",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "updatedAt": "Visto por último",
        "createdAt": "Visto primeiro",
        "linkedin": "Linkedin",
        "instagram": "Instagram",
        "pinterest": "Pinterest",
        "tumblr": "Tumblr",
        "billingEmail": "E-mail de faturamento",
        "billingPhone": "Telefone de faturamento",
        "shippingEmail": "E-mail de envio",
        "state": "Estado",
        "city": "Cidade",
        "country": "País",
        "deviceType": "Tipo de dispositivo",
        "browserName": "Nome do navegador",
        "osName": "Nome sistema operativo",
        "platform": "plataforma",
        "ltv": "CLV",
        "ordersCount": "Contagem de pedidos",
        "name": "Nome",
        "RichpanelPredictedCLV": "CLV previsto",
        "RichpanelAliveProbability": "Probabilidade de compra",
        "RichpanelNextOrderDate": "Próxima data de pedido",
        "RichpanelPredictedOrderCount": "Introduza seu e-mail para que possamos entrar em contato",
        "aov": "AOV",
        "WebsiteURL":"Link do site"
    },
    botMessages: {
        EXISITING_CUSTOMER: 'Você já é nosso cliente?',
        YES_EXISITING_CUSTOMER: "Sim, sou cliente",
        NO_EXISITING_CUSTOMER: "Não sou cliente ainda",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "Nos dê uma forma de entrar em contato",
        YOU_WILL_BE_NOTIFIED_EMAIL: "Enviaremos um e-mail no ({email}) ou responderemos via chat",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "Será notificado aqui quando responderem. ",
        LEAVE_YOUR_MESSAGE: "Por favor deixe sua mensagem",
        TEAM_WILL_BE_BACK_IN:"Nossa equipe vai estar de volta em {hours} horas",
        TEAM_WILL_BE_BACK_ON:"Nossa equipe  vai estar de volta {availableAt}",
        FEW_MORE_DETAILS: "Obrigado! Mais alguns detalhes vão ajudar a encaminhá-lo a pessoa certa:",
    },
    initialForm: {
        heading: 'Por favor introduza suas informações para iniciar o chat',
        startChat: 'Iniciar chat'
    },
    customerJourneyPreChatForm: {
        heading: 'Iniciar uma conversa',
        startChat: 'Iniciar conversa',
        proceed: 'Continuar',
        canWeHelpWithAnythingElse: 'Podemos ajudar com algo mais?',
        noThanks: "Obrigada",
        yesContactSupport: "Conversar com o suporte",
        contactSupport: "Contatar suporte",
    },
    rating: {
        askedHeader: 'Avalie a conversa',
        successHeader: 'Avaliou esta conversa',
        thanksMessage: "Obrigada por nos informar",
        placeholderForRatingFeedback: "Por favor deixe seu feedback"
    },
    placeholders: {
        emojiSearch: 'Procurar emojis',
        typeAMessage: 'Escrever uma mensagem',
        searchGifs: 'Procurar GIFs',
    },
    lastMessageText: {
        sentAGif: 'Enviou um GIF',
        sharedFile: 'Compartilhou um ficheiro',
        askedForQualificationDetails: 'Pediu por detalhes de qualificação',
        askedForRating: 'Pediu por classificação',
        askedForFeedback: 'Pediu feedback',
        sharedOrderSummary: "Compartilhou o resumo do pedido"
    },
    greetingAnimation: {
        weAreOnline: 'Estamos online',
        askUsAnything: 'Pergunte-nos qualquer coisa',
        chatWithUs: 'Fale connosco'
    }
}
